import { Despacho } from "./despacho.model";

/**Petición de inserción de pedido */
export class OrderInsertRequest {
    /**Canal */
    public channel: string;
    /**Código de cliente */
    public clientCode: string;
    /**Email */
    public emailAddress: string;
    /**Nombre completo */
    public fullName: string;
    /**Nombre completo */
    public documentType: string;
    public documentNumber: string;
    public despacho: Despacho;
    public conditionAccepted: boolean;
    public clauseAccepted:boolean;
}